import l from '../../../../lang';
import IntegrationCard from '../integration-card';
import { ReactComponent as BigcommerceIcon } from '../../../../assets/icons/integrations/bigcommerce.svg';
import { usePaymentIntegration } from '../../../../store/payment-integration';
import { DetailsOpened } from '../../../../store/payment-integration/interfaces';
import { segmentIntegrationsMenuHostinger } from '../../../../utils/analytics';

export default () => {
  const { setDetailsOpened } = usePaymentIntegration();

  return (
    <IntegrationCard
      title={l('paymentIntegration.bigcommerce.title')}
      icon={<BigcommerceIcon />}
      color="black"
      onDetails={() => {
        setDetailsOpened(DetailsOpened.BIGCOMMERCE);
      }}
      detailsText={l('paymentIntegration.card.integration.voting.link')}
    />
  );
};
